<template>
  <new-affiliates-account />
</template>

<script>
import NewAffiliatesAccount from '@/components/Affiliates/NewAffiliatesAccount'

export default {
  name: 'AffiliateAccountView',
  components: { NewAffiliatesAccount },
}
</script>
